module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Histórico do paciente " + _vm._s(_vm.historico.data[0] ? _vm.historico.data[0].solicitacao.paciente.nome : ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Histórico do sistema novo")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.historico.data), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(_vm._f("situacaoSolicitacao")(item.solicitacao.situacao)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.nome : item.contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.data_atendimento : item.contrato_subgrupo_atendimento.data_atendimento)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.profissional.nome : "SEM PROFISSIONAL"))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento.procedimento.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.solicitacao.created_at)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento.contrato.unidade.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.solicitacao.profissional.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.solicitacao.usuario.name))])])
  }))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("\n\t\t\t\t\t\t\tMostrando " + _vm._s(this.historico.from) + " até " + _vm._s(this.historico.to) + " de " + _vm._s(this.historico.total) + " registros encontrados.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 7,
      "data": _vm.historico
    },
    on: {
      "pagination-change-page": _vm.getHistorico
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Histórico importado da base de dados anterior")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.historicoAntigo.data), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(_vm._f("situacaoSolicitacaoAntiga")(item.situacao)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.unidade_realizadora))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.data_realizacao)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.profissional_realizador))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.procedimento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.data_solicitacao)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.unidade_solicitante))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.profissional_solicitante))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.profissional_marcador))])])
  }))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("\n\t\t\t\t\t\t\tMostrando " + _vm._s(this.historicoAntigo.from) + " até " + _vm._s(this.historicoAntigo.to) + " de " + _vm._s(this.historicoAntigo.total) + " registros encontrados.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 7,
      "data": _vm.historicoAntigo
    },
    on: {
      "pagination-change-page": _vm.getHistoricoAntigo
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Voltar")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Situação")]), _vm._v(" "), _c('th', [_vm._v("Unidade realizadora")]), _vm._v(" "), _c('th', [_vm._v("Data da realização")]), _vm._v(" "), _c('th', [_vm._v("Prof. Realizador")]), _vm._v(" "), _c('th', [_vm._v("Procedimento")]), _vm._v(" "), _c('th', [_vm._v("Solicitado em")]), _vm._v(" "), _c('th', [_vm._v("Unidade solicitante")]), _vm._v(" "), _c('th', [_vm._v("Prof. Solicitante")]), _vm._v(" "), _c('th', [_vm._v("Prof. Marcador")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Situação")]), _vm._v(" "), _c('th', [_vm._v("Unidade realizadora")]), _vm._v(" "), _c('th', [_vm._v("Data da realização")]), _vm._v(" "), _c('th', [_vm._v("Prof. Realizador")]), _vm._v(" "), _c('th', [_vm._v("Procedimento")]), _vm._v(" "), _c('th', [_vm._v("Solicitado em")]), _vm._v(" "), _c('th', [_vm._v("Unidade solicitante")]), _vm._v(" "), _c('th', [_vm._v("Prof. Solicitante")]), _vm._v(" "), _c('th', [_vm._v("Prof. Marcador")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-009d7a58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastros/pacientes/historico.vue
// module id = 782
// module chunks = 0